import React, { useMemo } from 'react';
import { Box, ChevronRightIcon, costFormater, Text } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { ROUTES } from '@/common';
import { DEFAULT_DATE_FORMAT } from '@/common/constants';
import Link from '@/modules/core/components/Link';

import { BannerPreviousInvoiceProps } from '../BannerReplenishmentPreview.types';

import {
  StyledArrowWrapper,
  StyledDimmedText,
  StyledDot,
  StyledFullWidthLink,
  StyledPreviousInvoiceRow,
} from './BannerReplenishmentPreview.styles';

export const BannerPreviousInvoice: React.FC<BannerPreviousInvoiceProps> = ({ date, amount, invoiceId }) => {
  const link = useMemo(
    () => (invoiceId ? ROUTES.FINOPS_PREFUND_VIEW(`${invoiceId}`) : ROUTES.FINOPS),
    [invoiceId]
  );

  return (
    <StyledFullWidthLink>
      <Link testId="dashboard_banner_replenishment-preview_previous-invoice_link" to={link}>
        <StyledPreviousInvoiceRow
          data-testid="dashboard_banner_replenishment-preview_previous-invoice"
          direction="row"
          align="center"
          justify="between"
          round="container1Round"
          pad={{ top: 'spacing12', bottom: 'spacing12', left: 'spacing12', right: 'spacing8' }}
        >
          <Box direction="column" gap="spacing4">
            <StyledDimmedText
              data-testid="dashboard_banner_replenishment-preview_previous-invoice_label"
              color="textOnColor"
              size="medium"
              weight={400}
            >
              Previous Invoice
            </StyledDimmedText>

            <Box direction="row" align="center" gap="spacing4">
              <Text
                data-testid="dashboard_banner_replenishment-preview_previous-invoice_amount"
                color="textOnColor"
                size="medium"
                weight={400}
              >
                {costFormater(amount, { isPrecision: true })}
              </Text>
              <StyledDot width="4px" height="4px" background="textOnColor" round="50%" flex={false} />
              <Text
                data-testid="dashboard_banner_replenishment-preview_previous-invoice_date"
                color="textOnColor"
                size="medium"
                weight={400}
              >
                {dayjs(date).format(DEFAULT_DATE_FORMAT)}
              </Text>
            </Box>
          </Box>

          <StyledArrowWrapper width="24px" height="24ox" align="center" justify="center" flex={false}>
            <ChevronRightIcon
              data-testid="dashboard_banner_replenishment-preview_previous-invoice_chevron"
              size="12px"
              color="iconOnColor"
            />
          </StyledArrowWrapper>
        </StyledPreviousInvoiceRow>
      </Link>
    </StyledFullWidthLink>
  );
};

export default BannerPreviousInvoice;
